import React from "react";

export default function AdminLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0D1729] text-white flex items-center justify-center p-6 grid-bg">
      <div className="max-w-md w-full hairline bg-[#152138] p-10" data-testid="admin-login-panel">
        <div className="mono-label mb-6">§ OPERATOR CONSOLE · RESTRICTED</div>
        <h1 className="font-serif-display text-4xl leading-tight">Operator login.</h1>
        <p className="text-slate-400 mt-4 text-sm">
          Authorised Google accounts only. This portal provides access to case ledger,
          lead intake, and SEO metadata controls for Sauderton Forensics.
        </p>
        <button onClick={startLogin} className="btn-primary w-full mt-10" data-testid="admin-google-login-btn">
          Sign in with Google
        </button>
        <div className="mt-8 border-t border-slate-800/70 pt-6 mono-label text-slate-500">
          Unauthorised access is logged and prosecuted.
        </div>
      </div>
    </div>
  );
}
